import clsx from "clsx";
import React, { FC } from "react";

import { Icon, IconName } from "../../icon";

export interface IconButtonProps
  extends Pick<
    React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    "onClick" | "className" | "disabled" | "title"
  > {
  icon: IconName;
  variant: "light" | "light-outline" | "primary" | "primary-overlay";
  size?: "default" | "extralarge" | "large" | "small";
  borderTransparency?: boolean;
}

export const IconButton: FC<IconButtonProps> = ({
  icon,
  variant,
  className,
  borderTransparency,
  size = "default",
  ...props
}) => {
  const iconSize = (() => {
    switch (size) {
      case "extralarge":
        return 64;
      case "large":
        return 35;
      case "small":
        return 20;
      default:
        return 28;
    }
  })();

  return (
    <button
      className={clsx(
        "rounded-full flex items-center justify-center transition-all active:scale-95",
        size === "extralarge" && "w-28 h-28",
        size === "large" && "w-14 h-14",
        size === "default" && "w-11 h-11",
        size === "small" && "w-8 h-8",
        !props.onClick && "cursor-default",
        variant === "light" && "bg-white shadow-md text-primary",
        props.onClick && variant === "light" && "hover:shadow-lg",
        variant === "light-outline" && "border border-white bg-transparent text-white",
        variant === "primary" && "border border-white bg-primary text-white",
        variant === "primary-overlay" && "bg-primary text-white",
        props.onClick && variant === "primary-overlay" && "bg-opacity-90 hover:bg-opacity-100",
        borderTransparency && `border-opacity-20`,
        className
      )}
      {...props}
    >
      <Icon icon={icon} size={iconSize} />
    </button>
  );
};
